import React from "react"
import { StaticQuery, graphql, Link } from "gatsby"
import Bio from "./Bio"
import "./sidebar.css"

import SocialLinks from "./SocialLinks"
import TechTags from "./TechTags"


const Sidebar = () => {
	return (
		<StaticQuery
		query={graphql`
		query SiteBioQuery {
			site {
				siteMetadata {
					title
					tagline
					author
					contacts {
						github
					}
					labels {
						tag
						tech
						name 
						size 
						color
					}
				}
			}
			allMarkdownRemark(
				limit: 10
				sort: { fields: [frontmatter___date], order: DESC }
				filter: { frontmatter: { published: { eq: true } } }
				) {
					edges {
						node {
							frontmatter {
								tags
							}
						}
					}
				}
			}
			`}
			render={data => (
				<div className="sidebar-main sticky-top text-center">
					<h1 className="head-logo" style={{ margin: 0 }}>
					<Link to="/"><div className="crops" /></Link></h1>
					<Bio author={data.site.siteMetadata.author} tagline={data.site.siteMetadata.tagline} />
					<SocialLinks contacts={data.site.siteMetadata.contacts} />
					<hr className="mt-4" />
					<div className="page-links">
						<Link to="/"><span className="d-block pt-1">CATEGORY</span></Link>
						<Link to="/about"><span className="d-block pt-1">ABOUT ME</span></Link>
						<Link to="/archive"><span className="d-block pt-1">ARCHIVE</span></Link>
					</div>
					<hr className="mt-4" />
					<div className="d-block mt-4 dicat">
						<TechTags labels={data.site.siteMetadata.labels} posts={data.allMarkdownRemark.edges} />
					</div>
				</div>
				)}
				/>
				)
			}
			
			export default Sidebar